// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1fCl4","right":"styles_right__3baT9"};